export const enum Themes {
    ADMIN = 'admin',
    SUPERADMIN = 'superadmin' 
}
